const PAGE_PADDING_UNITS = 4;
const TOOLBAR_SPACER_UNITS = 7;
const TOOLBAR_SPACER_MD_PX = 81;

// Mirrors the spacer rendered above route content in authenticated-layout-scene.tsx.
export const paneMaxHeight = (theme: any) => ({
  maxHeight: `calc(100dvh - ${theme.spacing(TOOLBAR_SPACER_UNITS + PAGE_PADDING_UNITS)})`,
  [theme.breakpoints.up('md')]: {
    maxHeight: `calc(100dvh - ${TOOLBAR_SPACER_MD_PX + parseFloat(theme.spacing(PAGE_PADDING_UNITS))}px)`,
  },
});
